export default __webpack_public_path__ + "e30614cc0e5412d4ae992cd15f47dd97.svg";